var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_037-school-material",
    "data-name": "037-school-material",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.69,
    height: 82.869,
    viewBox: "0 0 77.69 82.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_246",
    "data-name": "Trazado 246",
    d: "M160.833,16H147.884A3.89,3.89,0,0,0,144,19.884V87.216a1.294,1.294,0,0,0,1.295,1.295v1.295a3.89,3.89,0,0,0,3.884,3.884h10.359a3.89,3.89,0,0,0,3.884-3.884V88.511a1.294,1.294,0,0,0,1.295-1.295V19.884A3.89,3.89,0,0,0,160.833,16Zm1.295,69.921H146.59V43.191h15.538ZM146.59,40.6V38.443l3.237-4.316h9.064l3.237,4.316V40.6Zm10.359-9.064h-5.179V24.493l5.179,2.373ZM147.884,18.59h12.948a1.3,1.3,0,0,1,1.295,1.295V34.129l-1.554-2.072a1.291,1.291,0,0,0-1.036-.519v-5.5a1.3,1.3,0,0,0-.755-1.177L151.014,21.3a1.295,1.295,0,0,0-1.835,1.177v9.064a1.294,1.294,0,0,0-1.036.518l-1.554,2.072V19.884A1.3,1.3,0,0,1,147.884,18.59Zm12.948,71.216a1.3,1.3,0,0,1-1.295,1.295H149.179a1.3,1.3,0,0,1-1.295-1.295V88.511h12.948Zm0,0",
    transform: "translate(-120.693 -13.41)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_247",
    "data-name": "Trazado 247",
    d: "M181.179,252.486a5.184,5.184,0,0,0,5.179-5.179v-2.59h-2.59v2.59a2.59,2.59,0,1,1-5.179,0V229.179a2.59,2.59,0,0,1,5.179,0v12.948h2.59V229.179a5.179,5.179,0,1,0-10.359,0v18.128A5.184,5.184,0,0,0,181.179,252.486Zm0,0",
    transform: "translate(-147.514 -187.745)",
    fill: "#86888b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_248",
    "data-name": "Trazado 248",
    d: "M412.891,15.152l-1.607-5.145L409.026.981A1.294,1.294,0,0,0,407.769,0h-2.59a1.3,1.3,0,0,0-1.256.981l-2.256,9.028-1.607,5.145a1.243,1.243,0,0,0-.059.384V80.28a2.592,2.592,0,0,0,2.59,2.59h7.769a2.592,2.592,0,0,0,2.59-2.59V15.538a1.3,1.3,0,0,0-.058-.386Zm-2.532,57.358H402.59v-2.59h7.769Zm-3.884-55.963a3.854,3.854,0,0,0-2.59-1.01h-.931l.971-3.884h5.1L410,15.538h-.931A3.86,3.86,0,0,0,406.475,16.548ZM406.191,2.59h.568l1.618,6.474h-3.8Zm-3.6,15.538h1.295a1.3,1.3,0,0,1,1.295,1.295V67.331h-2.59Zm7.769,62.152H402.59V75.1h7.769Zm0-12.948h-2.59V19.422a1.3,1.3,0,0,1,1.295-1.295h1.295Zm0,0",
    transform: "translate(-335.259 0)",
    fill: "#003082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_249",
    "data-name": "Trazado 249",
    d: "M16.833,0H2.59A2.592,2.592,0,0,0,0,2.59V80.28a2.592,2.592,0,0,0,2.59,2.59H16.833a2.592,2.592,0,0,0,2.59-2.59V2.59A2.592,2.592,0,0,0,16.833,0ZM2.59,80.28V75.1H6.474v-2.59H2.59V67.331H9.064v-2.59H2.59V59.562H6.474v-2.59H2.59V51.793H9.064V49.2H2.59V44.024H6.474v-2.59H2.59V36.255H9.064v-2.59H2.59V28.486H6.474V25.9H2.59V20.717H9.064v-2.59H2.59V12.948H6.474v-2.59H2.59V2.59H16.833V80.28Zm0,0",
    transform: "translate(0 0)",
    fill: "#003082"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_250",
    "data-name": "Trazado 250",
    d: "M64,32h2.59v3.884H64Zm0,0",
    transform: "translate(-53.641 -26.821)",
    fill: "#86888b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_251",
    "data-name": "Trazado 251",
    d: "M308.91,38.994l-1.256-5.025v-2.43a1.337,1.337,0,0,0-.048-.351l-2.913-10.359a1.283,1.283,0,0,0-.923-.891V16h-2.59v3.939a1.285,1.285,0,0,0-.927.905l-2.913,10.844a1.324,1.324,0,0,0-.044.335v1.945l-1.256,5.025c-.011.044,0,.09,0,.135a1.225,1.225,0,0,0-.036.179V87.216a1.3,1.3,0,0,0,1.295,1.295V91.1a2.592,2.592,0,0,0,2.59,2.59h5.179a2.592,2.592,0,0,0,2.59-2.59v-2.59a1.294,1.294,0,0,0,1.295-1.295V39.308a1.229,1.229,0,0,0-.036-.179,1.346,1.346,0,0,0,0-.135Zm-2.551,46.928H298.59v-2.59h7.769Zm-7.769-5.179V40.6h7.769v40.14ZM299.6,35.423h5.747l.647,2.59h-7.042Zm.284-3.228,2.6-9.663,2.583,9.186v1.116h-5.179ZM305.064,91.1h-5.179v-2.59h5.179Zm0,0",
    transform: "translate(-248.091 -13.411)",
    fill: "#003082"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_252",
    "data-name": "Trazado 252",
    d: "M328,200h2.59v11.654H328Zm0,0",
    transform: "translate(-274.912 -167.629)",
    fill: "#86888b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.381094633a41862e34ec8f040a976f2a.svg";
export { ForwardRef as ReactComponent };